/*  This is custom js file
    to expand functional this theme
*/
(function ($) {

    var $ = jQuery = $;

       function hideSelectText() {
        $('.product-single__form .btn').removeClass('m-select-sz disabled');
        $('.js-choose-option').hide();
        if($('.page-content--product').length) {
            let urlPath = window.location.href;
            let variantId = urlPath.split('variant=')[1];
            let cssRule = $('.product-single__variants option[value="'+ variantId +'"]').attr('data-css_rule');
            if (cssRule != undefined) {
                if(cssRule.indexOf('PREORDER')+1 > 0 ){
                    $('.js-original-button-text').text('PREORDER')
                } else {
                    $('.js-original-button-text').text('ADD TO BAG')
                }
            }
           if (cssRule == undefined) {
                var options = document.querySelectorAll('.product-single__variants option');
                var allOutOfStock = true;
                options.forEach(function(option) {
                    if (option.getAttribute('data-css') !== "Out of stock") {
                        allOutOfStock = false;
                    }
                });

                if (allOutOfStock) {
                    $('.js-choose-option').text('SOLD OUT')
                }
            }
        } else {
            $(document).on('click', '.product-opt__btn', function() {
                setTimeout(function() {
                    let productId = ($('.custom-mobile-qv-p').attr('data-prod-id'));
                    let product = $(`.js-prod-item[data-id="${productId}"]`);
                    let variantId = '';
                    let cssRule = '';
                    $('.js-quick-vr').each(function() {
                        if(!!$(this).attr('data-vr')){
                            variantId = $(this).attr('data-vr');
                        }
                    })
                    cssRule = $(product).find(`[data-variant-id="${variantId}"]`).attr('data-variant-css');
                    if (cssRule != undefined) {
                        if(cssRule.indexOf('PREORDER')+1 > 0 ){
                            $('.js-choose-option').text('PREORDER')
                        } else {
                            $('.js-choose-option').text('ADD TO BAG')
                        }
                    }
                },500);
            })
            // $('.js-original-button-text').text('ADD TO BAG')
        }
        $('.js-original-button-text').show();
        $('.product-single__form .btn').prop("disabled", false);
    }

    function showSelectText() {
        $('.product-single__form .btn').addClass('m-select-sz');
        $('.js-choose-option').show();
        $('.js-original-button-text').hide();
    }

    function giveDisableOutOfStockVariantsTop() {
        $('.js-top, .js-size').each(function() {
            let option = $(this),
                bottomOption = $('.variant-input.m-bottom'),
                condition1 = option.hasClass('m-option-disable'),
                condition2 = option.hasClass('m-option-active');

            if (condition1) {
                bottomOption.removeClass('m-dsbl');
                bottomOption.find('input[type="radio"]').prop("disabled", false);
                bottomOption.removeClass('m-bottom')
                option.closest('.variant-input').addClass('m-dsbl m-top');
                option.closest('.variant-input').find('input[type="radio"]').prop("disabled", true);
            }
            if (condition2) {
                option.closest('.variant-input').removeClass('m-dsbl');
                option.closest('.variant-input').find('input[type="radio"]').prop("disabled", false);
            }
        });
    }
    
    function giveDisableOutOfStockVariantsBottom() {
        $('.js-bottom').each(function() {
            let option = $(this),
                parentWrap = $(this).closest('.hidden-out-param'),
                preventDisable = parentWrap.find('.m-option-active.m-bottom'),
                topOption = $('.variant-input.m-top'),
                condition1 = option.hasClass('dsbl') && !preventDisable.length,
                condition2 = !option.hasClass('dsbl') && preventDisable.length;

            if (condition1) {
                topOption.removeClass('m-dsbl');
                topOption.find('input[type="radio"]').prop("disabled", false);
                topOption.removeClass('m-top');
                option.closest('.variant-input').addClass('m-dsbl m-bottom');
                option.closest('.variant-input').find('input[type="radio"]').prop("disabled", true);
            }
            if (condition2) {
                topOption.removeClass('m-dsbl');
                topOption.find('input[type="radio"]').prop("disabled", false);
                topOption.removeClass('m-top')
            }
        });
    }

    function giveDisableOutOfStockVariants() {
  

        if ($('input[value="Bottom"]').is(":checked")) {
            giveDisableOutOfStockVariantsBottom()
        }  
          
        if ($('input[value="Top"]').is(":checked")) {
            giveDisableOutOfStockVariantsTop();
        }

        if ($('input[value="OS"]').is(":checked")) {
            giveDisableOutOfStockVariantsTop();
        }

        if ($('input[name="Size"]').is(":checked")) {
            giveDisableOutOfStockVariantsTop();
        }

        let conditionOutOfStock = $('.js-top').hasClass('m-option-active') || $('.js-bottom').hasClass('m-option-active') || $('.js-os').hasClass('m-option-active');

        if (!conditionOutOfStock) {
            hideSelectText();
        } else {
            showSelectText();
        }

    }

    $(document).on('change', '.product-single__form input[type="radio"]', function () {

        if ($('input[value="Top"]').is(":checked")) {
            $('fieldset[data-index="option3"]').closest('.variant-wrapper').hide();
            $('.variant-input[data-value="-"] input[value="-"]').prop('checked', true);
        }

      
         var $selectedTooltipOpt = $(this).closest('.product-single__form').find('.tooltip__variants option:selected');
         var tooltipContent = ($selectedTooltipOpt.attr('data-css') || '').trim();
         if (tooltipContent !== '') {
            $(this).closest('.product-single__form').find('.js-tooltip:not(.sold-as-set)').removeClass('m-tool-hide')
        } else {
            $(this).closest('.product-single__form').find('.js-tooltip:not(.sold-as-set)').addClass('m-tool-hide')
        }

        if($('.product-option-set').length) {

            let finalSale = $('.product-single__variants option:selected').attr('data-final_sale');
            $('.product-single__form .shipping-from-date-prod').text(finalSale);


            $('input[data-index="option1"]').on('click', function () {

                $('input[data-index="option2"]').prop('checked', false);
                $('input[data-index="option3"]').prop('checked', false);
                $('fieldset[data-index="option3"]').closest('.variant-wrapper').hide();
                $('.css-status').removeClass('m-show');
                $('.product__inventory.m-show').hide();

                giveDisableOutOfStockVariants()
            });

            $('input[data-index="option2"]').on('click', function () {
                $('input[data-index="option3"]').prop('checked', false);
                $('.variant-input[data-index="option3"] .variant__button-label').removeClass('disabled');
            });

            if ($('.product-single__form span').hasClass('grouped-fits') || $('.product-single__form span').hasClass('std-fits')){
                    $('input[data-index="option2"]').on('click', function () {
                        if ($('input[value="Bottom"]').is(":checked")) {
                            $(this).prop('checked', true);
                            $('fieldset[data-index="option3"]').closest('.variant-wrapper').show();
                        }
                        if ($('input[value="Top"]').is(":checked")) {
                            $('.css-status').addClass('m-show');
                            $('.product__inventory.m-show').show();
                        }
                    })
                    $('input[data-index="option3"]').on('click', function () {
                        $('.css-status').addClass('m-show');
                        $('.product__inventory.m-show').show();
                    });
                }

            if ($('.product-single__form span').hasClass('grouped') || $('.product-single__form span').hasClass('std')){
                $('input[data-index="option2"]').on('click', function () {
                    $('.css-status').addClass('m-show');
                    $('.product__inventory.m-show').show();
                });


                if ($('input[data-index="option1"][name="Size"]').is(":checked")) {
                    $('.css-status').addClass('m-show');
                    $('.product__inventory.m-show').show();
                }
            }

            if ($('.product-single__form span').hasClass('std-fits')) {
                if($('fieldset[data-index="option1"][name="Size"]')){
                    $('input[data-index="option2"]').on('click', function () {
                        $('.css-status').addClass('m-show');
                        $('.product__inventory.m-show').show();
                    });
                }
            }
            
            $('input[value="Bottom"]').removeAttr('disabled');
            $('.variant-input[data-value="Bottom"] .variant__button-label').removeClass('disabled');
            $('input[value="Top"]').removeAttr('disabled');
            $('.variant-input[data-value="Top"] .variant__button-label').removeClass('disabled');

            let conditionHideSelectText = $('.css-status').hasClass('m-show'),
                cssText = $('.css-status-msg').text()

            if( cssText.length > 0){
                if (conditionHideSelectText) {
                    hideSelectText();
                } else {
                    showSelectText();
                }
            }

            let variantId = $('.product-single__variants').val();

            setTimeout(function() {
                if ($(".css-status").hasClass('m-show')) {
                    $('.m-variant-sale').hide()
                    $('.m-variant-sale[data-vr-id="'+variantId+'"]').show()
                    let finalSale = $('.final-sale').attr('value');
                    $('.fs-cart').val(finalSale)
                } else {
                    $('.m-variant-sale').hide();
                    $('.fs-cart').val('')
                }
            }, 300);
        }else {
          	if($('.product-single__form .css-status').hasClass('css-status__one-select')) {
                $('.product-single__form .css-status').removeClass('css-status__one-select')
            }
            let variableCss = $('.product-single__variants option:selected').attr('data-css')
            $('.css-drawer').val(variableCss);
        
            setTimeout(function(){ $('.product-single__form .css-status').removeClass('m-hide-css') }, 200);
            $('.product-single__form .css-status-msg').text(variableCss);
            $('.product-single__form .css-status').addClass('m-hide-css')

            // tooltip custom_stock_status — hide when Out of stock OR when no tooltip content (e.g. In Stock)
            if(variableCss === 'Out of stock' || !variableCss || variableCss.trim() === '') {
                $('.js-tooltip').addClass('js-tooltip_none');
            } else {
                if($('.js-tooltip').hasClass('js-tooltip_none')) {
                    $('.js-tooltip').removeClass('js-tooltip_none');
                }
                let variantProduct = $('.product-single__variants option:selected').attr('value')
                $('.tooltip__variants .tooltip__variant').each(function(index,value) {
                    if(variantProduct === $(value).attr('value')) {
                        $(value).closest('.tooltip').removeClass('tooltip__instock')
                        let variableCssTooltip = $(value).attr('data-css')
                        let instock = $(value).attr('data-quantity')
                        if ( instock === 'instock') {
                            $(value).closest('.tooltip').addClass('tooltip__instock')
                        } else {
                            $('.tooltip__css-status-msg').html(variableCssTooltip);
                        }
                    }
                });
            }
            

            let finalSale = $('.product-single__variants option:selected').attr('data-final_sale');
            $('.product-single__form .shipping-from-date-prod').text(finalSale);

            var $sel = $('.product-single__variants option:selected');
            var $shipsSpanO = $('.product-single__form .ships_from_country');
            if ($shipsSpanO.length && $sel.length) {
                var shipsFromCountry = $sel.attr('data-ships-from-country');
                var invQty = parseInt($sel.attr('data-inventory-quantity') || '0', 10);
                var isUs = $('.product-single__form .js-form-intl-ddu').attr('data-currency') === 'USD';
                var hasTag = $('.product-single__form .js-form-intl-ddu').attr('data-intl-ddu') === 'true';
                if (isUs && hasTag && invQty < 1 && shipsFromCountry) {
                    var shipsText = 'Ships from ' + shipsFromCountry + '. May be subject to customs/tariffs.';
                    $shipsSpanO.text(shipsText).css('opacity', 1);
                    $('.ships-from-country-drawer').val(shipsText);
                    console.log('[ships_from_country one-select] SHOW', shipsText);
                } else {
                    $shipsSpanO.css('opacity', 0).text('');
                    $('.ships-from-country-drawer').val('');
                }
            }

            $('input[data-index="option1"]').on('click', function () {

                $('input[data-index="option2"]').prop('checked', false);
                $('input[data-index="option3"]').prop('checked', false);
                $('fieldset[data-index="option3"]').closest('.variant-wrapper').hide();
                $('.css-status').removeClass('m-show');
                $('.product__inventory.m-show').hide();

                giveDisableOutOfStockVariants()
            });

            $('input[data-index="option2"]').on('click', function () {
                $('input[data-index="option3"]').prop('checked', false);
                $('.variant-input[data-index="option3"] .variant__button-label').removeClass('disabled');
            });

            if ($('.product-single__form span').hasClass('grouped-fits') || $('.product-single__form span').hasClass('std-fits')){
                    $('input[data-index="option2"]').on('click', function () {
                        if ($('input[value="Bottom"]').is(":checked")) {
                            $(this).prop('checked', true);
                            $('fieldset[data-index="option3"]').closest('.variant-wrapper').show();
                        }
                        if ($('input[value="Top"]').is(":checked")) {
                            $('.css-status').addClass('m-show');
                            $('.product__inventory.m-show').show();
                        }
                    })
                    $('input[data-index="option3"]').on('click', function () {
                        $('.css-status').addClass('m-show');
                        $('.product__inventory.m-show').show();
                    });
                }

            if ($('.product-single__form span').hasClass('grouped') || $('.product-single__form span').hasClass('std')){
                $('input[data-index="option2"]').on('click', function () {
                    $('.css-status').addClass('m-show');
                    $('.product__inventory.m-show').show();
                });


                if ($('input[data-index="option1"][name="Size"]').is(":checked")) {
                    $('.css-status').addClass('m-show');
                    $('.product__inventory.m-show').show();
                }
            }

            if ($('.product-single__form span').hasClass('std-fits')) {
                if($('fieldset[data-index="option1"][name="Size"]')){
                    $('input[data-index="option2"]').on('click', function () {
                        $('.css-status').addClass('m-show');
                        $('.product__inventory.m-show').show();
                    });
                }
            }
            
            $('input[value="Bottom"]').removeAttr('disabled');
            $('.variant-input[data-value="Bottom"] .variant__button-label').removeClass('disabled');
            $('input[value="Top"]').removeAttr('disabled');
            $('.variant-input[data-value="Top"] .variant__button-label').removeClass('disabled');

            let conditionHideSelectText = $('.css-status').hasClass('m-show'),
                cssText = $('.css-status-msg').text()

            if( cssText.length > 0){
                if (conditionHideSelectText) {
                    hideSelectText();
                } else {
                    showSelectText();
                }
            }

            let variantId = $('.product-single__variants').val();

            setTimeout(function() {
                if ($(".css-status").hasClass('m-show')) {
                    $('.m-variant-sale').hide()
                    $('.m-variant-sale[data-vr-id="'+variantId+'"]').show()
                    let finalSale = $('.final-sale').attr('value');
                    $('.fs-cart').val(finalSale)
                } else {
                    $('.m-variant-sale').hide();
                    $('.fs-cart').val('')
                }
            }, 300);
        }

        setTimeout(function() {
        if ($('.css-status-msg').text() == 'Out of stock') {
            $('.add-to-cart').addClass('m-select-sz')
        }
        }, 100);
    });

    // Initial-paint hydration: the css-status text only populates inside the
    // 'change' handler above, which fires on user interaction. If the user
    // clicks a size BEFORE this script's IIFE has run (race between paint and
    // script-parse), the browser checks the radio but no handler runs, so the
    // status never appears until they click a second size. Fire change once on
    // DOM-ready for whatever radio is already :checked so the status hydrates
    // immediately — whether the check came from the URL variant or an early
    // user click.
    $(function() {
        $('.product-single__form input[type="radio"]:checked').each(function() {
            $(this).trigger('change');
        });
    });

       function tooltip () {
        let windowWidth = $(window).width();
        let docHeight = $(document).height();
        $('.js-tooltip').each(function(index,value) {
            if (windowWidth > '768') {
                if($(value).hasClass('tooltip__button_clickable')) {
                    $(value).on('click', function() {
                        if($(this).children('.tooltip__block').hasClass('tooltip__block_open')) {
                            $(this).children('.tooltip__block').removeClass('tooltip__block_open');
                        } else {
                            $(this).children('.tooltip__block').addClass('tooltip__block_open');
                            let elementHeight = $(this).offset().top;
                            let blockHeight = $(this).children('.tooltip__block').outerHeight(true)
                            let valueHeight = $(this).outerHeight(true)
                            if (elementHeight + blockHeight > docHeight) {
                                $(this).children('.tooltip__block').css({bottom:valueHeight})
                            }
                        }
                        $(this).children('.tooltip__block').on('mouseleave', function() {
                            $(this).removeClass('tooltip__block_open');
                        })
                    })
                } else {
                    $(value).hover( 
                        function() {
                            $(value).children('.tooltip__block').addClass('tooltip__block_open');
                            let elementHeight = $(value).offset().top;
                            let blockHeight = $(value).children('.tooltip__block').outerHeight(true)
                            let valueHeight = $(value).outerHeight(true)
                            if (elementHeight + blockHeight > docHeight) {
                                $(value).children('.tooltip__block').css({bottom:valueHeight})
                            }
    
                        },function() {
                            $(value).children('.tooltip__block').removeClass('tooltip__block_open');
                        }
                    );
                }
            } else {
                $(value).on('click', function() {
                    $(value).children('.tooltip__block').appendTo( $(value).parent());
                    $(value).next().next().addClass('tooltip__block_open');
                    $('.tooltip__block_open').css({width:'100%'})
                    let tooltipHeight = $('.tooltip__block_open').outerHeight(true) - 25;
                    $('.tooltip__close__wrapper').css({bottom: tooltipHeight});

                    $(value).parent().append('<div class="tooltip__background"></div>')
                    $('html, body').css({overflow: 'hidden'});
    
                })
                $('.js-tooltip-btn-close , .js-tooltip__cross-close' ).on('click', function() {
                    $(this).closest('.tooltip__block').removeClass('tooltip__block_open');
                    $(this).closest('.tooltip__block').appendTo($(this).closest('.tooltip__button'));

                    $('.tooltip__background').remove();
                    $('html, body').css({overflow: 'auto'});
                });
                $(document).mouseup(function (e) {
                    let container = $('.tooltip__wrapper'); 
    
                    if (container.has(e.target).length === 0){

                        $(value).next().next().removeClass('tooltip__block_open');
                        $(value).children('.tooltip__block').appendTo($(value));
                        $('.tooltip__background').remove();
                        $('html, body').css({overflow: 'auto'});
                    }
                });
            }
        })

    }

    tooltip ();

    $(document).on('click', '.m-btn-wrap', function(e) {
        e.stopPropagation();
        e.preventDefault();
        setTimeout(function() {
            tooltip();
        },1000);
    });

    // Sale banner
    
    if (sessionStorage.getItem('notice-close') == 'true') {
        $('.sw-notice-desktop , .sw-notice-mobile').hide();
    } else {
        sessionStorage.clear()
    }

    $('.notice-close').click(function (e) {
        $('.sw-notice-desktop').slideToggle();
        sessionStorage.setItem('notice-close', 'true')
    });

    $('.notice-close-mob').click(function (e) {
        $('.sw-notice-mobile').slideToggle();
        sessionStorage.setItem('notice-close', 'true')
    });

    $('.pane-trigger').click(function (e) {
        $('.pane-content.details').slideToggle();
    });

    $(document).ready(function () {

        $('.email_popup').click(function () {
            $('#newsletter-footer').show();
        });

        $('.size-fit-guide:not(.qv)').click(function (e) {
            e.preventDefault();
            let vendorProduct = $('.js-prod-vendor').val();
            fetch(window.Shopify.routes.root + "?sections=size-chart-"+ vendorProduct +"")
            .then((res) => {
                return res.json();
            })
            .then((data) => {
                let html = $.parseHTML(data[Object.keys(data)[0]])
                $(".size-popup").append(html);
                $('.size-popup').show();
                $('body').addClass('m-submenu-opened m-pu-size');
                $('.size-chart-table table').each(function() {
                    if ($(window).width() < 769) {
                       $(this).wrap('<div class="scrollable-table-container"></div>');
                    }
                });
            })
        });

        $(document).on('click', '.template-product .close', function() {
            $('#newsletter-footer , .size-popup').hide();
            $('.size-popup .shopify-section').remove()
            $('body').removeClass('m-submenu-opened m-pu-size');
        });

        $(document).mouseup(function (e) {
            if ($(e.target).closest(".size-popup").length
            === 0 && $('.size-popup').is(':visible')) {
                $('.close').trigger('click')
            }
        });

        $('.ssl').click(function () {
            $('.custom-ssl').show();
        });

        $('.close').click(function () {
            $('.custom-ssl').hide();
        })

        $('#collapse-helpMenu').click(function (e) {
            $('.span-4.leftside').slideToggle();

        });

        $('.variant-input[data-value="-"]').hide();
        if ($('input[value="Top"]').is(":checked")) {
            $('fieldset[data-index="option3"]').closest('.variant-wrapper').hide();
          console.log(572)
            $('.variant-input[data-value="-"] .variant__button-label').trigger("click");
        }
        $('input[class^="variant__input"]').removeAttr('disabled');
        $('.variant-input[data-value="Bottom"] .variant__button-label').removeClass('disabled');
        $('.variant-input[data-value="Top"] .variant__button-label').removeClass('disabled');


        if($("div").is(".variant-wrapper") == false){
            $('.css-status').addClass('m-show');
            $('.product__inventory').addClass('m-show');
        }

        let variableCss = $('.product-single__variants option:selected').attr('data-css')
        $('.product-single__form .css-status-msg').text(variableCss);
        var $sel = $('.product-single__variants option:selected');
        var $shipsSpanO = $('.product-single__form .ships_from_country');
        if ($shipsSpanO.length && $sel.length) {
            var shipsFromCountry = $sel.attr('data-ships-from-country');
            var invQty = parseInt($sel.attr('data-inventory-quantity') || '0', 10);
            var isUs = $('.product-single__form .js-form-intl-ddu').attr('data-currency') === 'USD';
            var hasTag = $('.product-single__form .js-form-intl-ddu').attr('data-intl-ddu') === 'true';
            if (isUs && hasTag && invQty < 1 && shipsFromCountry) {
                var shipsText = 'Ships from ' + shipsFromCountry + '. May be subject to customs/tariffs.';
                $shipsSpanO.text(shipsText).css('opacity', 1);
                $('.ships-from-country-drawer').val(shipsText);
            } else {
                $shipsSpanO.css('opacity', 0).text('');
                $('.ships-from-country-drawer').val('');
            }
        }
        setTimeout(function(){

            // if ($('.variant-input-wrap[data-index="option1"] .variant-input').length) {
            //     // $('.variant-input-wrap[data-index="option1"] .variant-input').first().children('.variant__button-label')[0].click();
            //     $('.variant-input-wrap[data-index="option1"] .variant-input .variant__button-label:not(.disabled)')[0].click();
            // }

            $('.product__inventory.m-show').hide();
            if ($('input[value="Bottom"]').is(":checked")) {
                $('fieldset[data-index="option3"]').closest('.variant-wrapper').hide();
              console.log(597)
                $('.variant-input[data-value="-"] .variant__button-label').trigger("click");
            }

            if ($('input[name="Size"]').is(":checked")) {
                $('.m-option-active').closest('.variant-input').find('.variant__button-label').addClass("asd").trigger("click");
                if ($('.m-option-active').length) {
                    hideSelectText()
                }
            }
        }, 300);

        /* SUBHEADER ANIMATION */

        /* $(".subheader-items").animate({marginLeft:'-140px'},500); */

        if($('#retired-tag').val() == "true"){
            $('body').addClass('retired');
        }
 
    });

    $(window).on('load', function(){

        /* Add disable to out of stock variant */

        giveDisableOutOfStockVariants()


        var getUrlParameter = function getUrlParameter(sParam) {
            var sPageURL = window.location.search.substring(1),
                sURLVariables = sPageURL.split('&'),
                sParameterName,
                i;
        
            for (i = 0; i < sURLVariables.length; i++) {
                sParameterName = sURLVariables[i].split('=');
        
                if (sParameterName[0] === sParam) {
                    return typeof sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
                }
            }
            return false;
        };

        let variantUrl = getUrlParameter('variant');

        if (variantUrl != false && $('.product-single__variants option:selected').data('css') != "Out of stock" && !$('body').hasClass('gift-card')) {

            let selectedVariant = $('.product-single__variants').val(),
                optionParam1 = $('.product-single__variants option:selected').data('option1'),
                optionParam2 = $('.product-single__variants option:selected').data('option2'),
                optionParam3 = $('.product-single__variants option:selected').data('option3');
                
            if (variantUrl == selectedVariant) {
                
                if (optionParam1 != '') {
                    $('.variant-input[data-value="'+ optionParam1 +'"] .variant__button-label').trigger('click') 
                    $('.variant-input-wrap input[value="'+optionParam1+'"]').trigger('click')
                }
                if (optionParam2 != '') {
                    $('.variant-input[data-value="'+ optionParam2 +'"] .variant__button-label').trigger('click')
                    $('.variant-input-wrap input[value="'+optionParam2+'"]').trigger('click') 
                }
                if (optionParam3 != '') {
                    $('.variant-input[data-value="'+ optionParam3 +'"] .variant__button-label').trigger('click')
                }
                
                $('.css-status').addClass('m-show');

                $('.product__inventory').addClass('m-show');

                hideSelectText()  
        
            }

        } else {

            showSelectText()

            let variantsWpaeer = $('.variant-wrapper.js').length;

          
 
          let $variants = $('.variant-wrapper.js');
          let variantsCount = $variants.length;
          
          if (variantsCount > 1) {
              // If there are exactly two variant wrappers, check if their names are "Size" and "Fit"
              if (variantsCount === 2) {
                  let firstName = $variants.eq(0).find('.variant-input-wrap').attr('name');
                  let secondName = $variants.eq(1).find('.variant-input-wrap').attr('name');
          
                  // Check if the two names are exactly "Size" and "Fit" (order doesn't matter)
                  if ((firstName === 'Size' && secondName === 'Fit') ||
                      (firstName === 'Fit' && secondName === 'Size')) {
                      // We have only 2 elements with Size and Fit, so do nothing.
                      $variants.eq(1).find('.variant-input-wrap').closest('.variant-wrapper').hide()
                      console.log('Only Size and Fit found, no elements hidden.');
                  } else {
                      // Not the expected two variants, so apply hiding logic
                      $variants.each(function(index) {
                          if (index !== 4) {
                              $(this).hide();
                          }
                      });
                  }
              } else {
                  // More than two variants: hide all except the one at index 4.
                  $variants.each(function(index) {
                      if (index !== 4) {
                          $(this).hide();
                      }
                  });
              }
          }
    
            $(document).on('change', '.variant-input-wrap input', function () {
                if ($(this).data('index') == 'option1') {
                    $('.variant-input-wrap[data-index="option2"]').closest('.variant-wrapper.js').show()
                    $(this).trigger('click')
                }
                if ($(this).data('index') == 'option2' && !$('input[value="Top"]').is(":checked")) {
                    $('.variant-input-wrap[data-index="option3"]').closest('.variant-wrapper.js').show()
                }

                if ($(this).is(':checked') && variantsWpaeer == 1) {
                    $('.css-status').addClass('m-show');
                }
            });

            if ($('body').hasClass('gift-card') && variantUrl != false && $('.product-single__variants option:selected').data('css')) {
                optionParam1 = $('.product-single__variants option:selected').data('option1');
                $('.variant-input[data-value="'+ optionParam1 +'"] .variant__button-label').trigger('click') 
                $('.variant-input-wrap input[value="'+optionParam1+'"]').trigger('click')    
                $('.css-status').addClass('m-show');
                $('.product__inventory').addClass('m-show');
            }

        }

        /* Custom only Top/Bottom */

        $(".m-only-arr").each(function() {
            let arrayTitles = $(this).find("input").toArray().map(item => item.dataset.tittle),
                top = $(this).find(".top"),
                bottom = $(this).find(".bottom");

            if( arrayTitles.includes('Top') == true && arrayTitles.includes('Bottom') != true){
                top.addClass('label-show');
            } else if ( arrayTitles.includes('Top') != true && arrayTitles.includes('Bottom') == true) {
                bottom.addClass('label-show');

            }

        });

        /* Custom save price for "you may also like" */
        
        $('.product-recommendations .grid-product__price').each(function () {
            let oldPrice = $(this).find('#old-price').val(),
                currentPrice = $(this).find('#current-price').val(),
                discountPrice = (oldPrice - currentPrice)/100;

            if( discountPrice > 0 ){
                // $(this).find('.grid-product__price--savings').text('Save $' + discountPrice.toFixed(2))
            }
        })

        /* Disable product form preloader after loading */

        if ($('.product-preloader').length) {
            $('.product-preloader').removeClass('m-active')
        }
      
        /* Sale after discount code */

          function checkFinalSale() {
              let discountStored = localStorage.getItem('discount_code'),
                  finalSale = '',
                  productSale = ''; 
              $.getJSON('/cart.js', function(cart) {
                  let items = cart.items;
                  for(var i=0; i < items.length; i++){
                      let cartItem = items[i];
                      $.getJSON(`/products/${items[i].handle}`, function(product) {
                          let variantId = cartItem.variant_id,
                              variantObj = (product.product.variants).find(x => x.id === variantId);
                              productSale = Math.round(itemSale(variantObj.price, variantObj.compare_at_price));
                          if(discountStored && !product.product.tags.includes(discountStored)) {
                              let totalSalePrice = ($('.docapp-cart-discount').html().replace(/<.*>/g, ""));
                              finalSale = (parseInt(totalSalePrice.replace(/\D+/g,""), 10) + productSale);
                              if(finalSale >= 40) {
                                  addCartItemProperties(cartItem);
                              } else {
                                  removeCartItemProperties(cartItem)
                              }   
                          } else {
                              if(productSale >= 40) {
                                  addCartItemProperties(cartItem);
                              } else {
                                  removeCartItemProperties(cartItem)
                              }
                          } 
                      })
                  }
              });
          }
          function addCartItemProperties(item) {
              let finalSaleText = "Item is Final Sale. No return/exchange allowed.",
                  elemAjaxCart = $(`div[data-ajax-id="${item.id}"]`),
                  elemCart  = $(`div[data-id="${item.id}"]`);
              if(!item.properties.FinalSale) {
                  let newProp = item.properties;
                  newProp.FinalSale = finalSaleText;
                  // $.ajax({
                  //     type: 'POST',
                  //     url: '/cart/change.js', 
                  //     data: { properties: newProp, id: item.key  }, 
                  //     dataType: 'json'
                  // });
              }
              if($('.final-sale-minibag').length <= 0) {
                  $(elemAjaxCart).append(
                      `<span class="final-sale-minibag">FinalSale: Item is Final Sale. No return/exchange allowed.</span>`
                  )
              }
              $(elemAjaxCart).find('.final-sale-minibag').show();
              if($('body').hasClass('template-cart')) {
                  $(elemCart).find('.property-item').text(finalSaleText).show();
              }
          }
          function removeCartItemProperties(item) {
              let elemAjaxCart = $(`div[data-ajax-id="${item.id}"]`),
                  elemCart  = $(`div[data-id="${item.id}"]`);
              if(item.properties.FinalSale != "undefined") {
                  let prop = item.properties;
                  delete prop.FinalSale;
                  // $.ajax({
                  //     type: 'POST',
                  //     url: '/cart/change.js', 
                  //     data: { properties: prop, id: item.key }, 
                  //     dataType: 'json'
                  // });
              }
              $(elemAjaxCart).find('.final-sale-minibag').hide();

              if($('body').hasClass('template-cart')) {
                  $(elemCart).find('.property-item').hide();
              }
          }
          function itemSale(price, compare_at_price) {
              let percentSale;
              if(compare_at_price !="") {
                  percentSale = ((compare_at_price - price) * 100)/compare_at_price;
              } else {
                  percentSale = 0;
              }
              return percentSale;
          }
          document.body.addEventListener('docapp-discount-applied', (e) => {
              checkFinalSale();
          });

      });

})(theme.jQuery);
